import favicon from 'JS/automated/favicon.js';

// Based on files generated into /img/meta/
// If favicon files are saved into a different location, update the object below

export const faviconVueMeta = {
  link: [
    /**
     * We use `rel="icon"` instead of `rel="shortcut icon"` because "shortcut" is a deprecated and unsupported
     * attribute from IE8 and earlier. (IE8 and earlier browsers will fall back to searching for `favicon.ico` at our
     * site's root, so they will still correctly display our favicon.) https://mathiasbynens.be/notes/rel-shortcut-icon
     */
    { rel: 'icon', href: `https://assets.kodak.com/favicon.ico` },
    // { rel: 'icon', type: 'image/png', sizes: '16x16', href: `/${favicon.distPath}favicon-16x16.png` },
    // { rel: 'icon', type: 'image/png', sizes: '32x32', href: `/${favicon.distPath}favicon-32x32.png` },
    // { rel: 'icon', type: 'image/png', sizes: '48x48', href: `/${favicon.distPath}favicon-48x48.png` },
    // { rel: 'manifest', href: `/${favicon.distPath}manifest.json` },
    // { rel: 'apple-touch-icon', sizes: '57x57', href: `/${favicon.distPath}apple-touch-icon-57x57.png` },
    // { rel: 'apple-touch-icon', sizes: '60x60', href: `/${favicon.distPath}apple-touch-icon-60x60.png` },
    // { rel: 'apple-touch-icon', sizes: '72x72', href: `/${favicon.distPath}apple-touch-icon-72x72.png` },
    // { rel: 'apple-touch-icon', sizes: '76x76', href: `/${favicon.distPath}apple-touch-icon-76x76.png` },
    // { rel: 'apple-touch-icon', sizes: '114x114', href: `/${favicon.distPath}apple-touch-icon-114x114.png` },
    // { rel: 'apple-touch-icon', sizes: '120x120', href: `/${favicon.distPath}apple-touch-icon-120x120.png` },
    // { rel: 'apple-touch-icon', sizes: '144x144', href: `/${favicon.distPath}apple-touch-icon-144x144.png` },
    // { rel: 'apple-touch-icon', sizes: '152x152', href: `/${favicon.distPath}apple-touch-icon-152x152.png` },
    // { rel: 'apple-touch-icon', sizes: '167x167', href: `/${favicon.distPath}apple-touch-icon-167x167.png` },
    // { rel: 'apple-touch-icon', sizes: '180x180', href: `/${favicon.distPath}apple-touch-icon-180x180.png` },
    {
      rel: 'apple-touch-icon',
      sizes: '1024x1024',
      href: `/${favicon.distPath}apple-touch-icon-1024x1024.png`,
    },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-640x1136.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-750x1334.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-828x1792.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1125x2436.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1242x2208.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1242x2688.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1536x2048.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1668x2224.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1668x2388.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2048x2732.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1620x2160.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1136x640.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1334x750.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-1792x828.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2436x1125.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2208x1242.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2688x1242.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2048x1536.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2224x1668.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2388x1668.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2732x2048.png`,
    // },
    // {
    //   rel: 'apple-touch-startup-image',
    //   media:
    //     '(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)',
    //   href: `/${favicon.distPath}apple-touch-startup-image-2160x1620.png`,
    // },
    // { rel: 'icon', type: 'image/png', sizes: '228x228', href: `/${favicon.distPath}coast-228x228.png` },
    // { rel: 'yandex-tableau-widget', href: `/${favicon.distPath}yandex-browser-manifest.json` },
  ],
  meta: [
    { name: 'mobile-web-app-capable', content: 'yes' },
    { name: 'theme-color', content: favicon.themeColor || '#fff' },
    { name: 'application-name' },
    { name: 'apple-mobile-web-app-capable', content: 'yes' },
    { name: 'apple-mobile-web-app-status-bar-style', content: 'black-translucent' },
    { name: 'apple-mobile-web-app-title' },
    { name: 'msapplication-TileColor', content: favicon.tileColor || '#fff' },
    { name: 'msapplication-TileImage', content: `/${favicon.distPath}mstile-144x144.png` },
    { name: 'msapplication-config', content: `/${favicon.distPath}browserconfig.xml` },
  ],
};

// Reference output from favicons npm module

// <link rel="shortcut icon" href="/img/meta/favicon.ico">
// <link rel="icon" type="image/png" sizes="16x16" href="/img/meta/favicon-16x16.png">
// <link rel="icon" type="image/png" sizes="32x32" href="/img/meta/favicon-32x32.png">
// <link rel="icon" type="image/png" sizes="48x48" href="/img/meta/favicon-48x48.png">
// <link rel="manifest" href="/img/meta/manifest.json">
// <meta name="mobile-web-app-capable" content="yes">
// <meta name="theme-color" content="#fff">
// <meta name="application-name">
// <link rel="apple-touch-icon" sizes="57x57" href="/img/meta/apple-touch-icon-57x57.png">
// <link rel="apple-touch-icon" sizes="60x60" href="/img/meta/apple-touch-icon-60x60.png">
// <link rel="apple-touch-icon" sizes="72x72" href="/img/meta/apple-touch-icon-72x72.png">
// <link rel="apple-touch-icon" sizes="76x76" href="/img/meta/apple-touch-icon-76x76.png">
// <link rel="apple-touch-icon" sizes="114x114" href="/img/meta/apple-touch-icon-114x114.png">
// <link rel="apple-touch-icon" sizes="120x120" href="/img/meta/apple-touch-icon-120x120.png">
// <link rel="apple-touch-icon" sizes="144x144" href="/img/meta/apple-touch-icon-144x144.png">
// <link rel="apple-touch-icon" sizes="152x152" href="/img/meta/apple-touch-icon-152x152.png">
// <link rel="apple-touch-icon" sizes="167x167" href="/img/meta/apple-touch-icon-167x167.png">
// <link rel="apple-touch-icon" sizes="180x180" href="/img/meta/apple-touch-icon-180x180.png">
// <link rel="apple-touch-icon" sizes="1024x1024" href="/img/meta/apple-touch-icon-1024x1024.png">
// <meta name="apple-mobile-web-app-capable" content="yes">
// <meta name="apple-mobile-web-app-status-bar-style" content="black-translucent">
// <meta name="apple-mobile-web-app-title">
// <link rel="apple-touch-startup-image" media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"    href="/img/meta/apple-touch-startup-image-640x1136.png">
// <link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"    href="/img/meta/apple-touch-startup-image-750x1334.png">
// <link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"    href="/img/meta/apple-touch-startup-image-828x1792.png">
// <link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"    href="/img/meta/apple-touch-startup-image-1125x2436.png">
// <link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"    href="/img/meta/apple-touch-startup-image-1242x2208.png">
// <link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: portrait)"    href="/img/meta/apple-touch-startup-image-1242x2688.png">
// <link rel="apple-touch-startup-image" media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"   href="/img/meta/apple-touch-startup-image-1536x2048.png">
// <link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"   href="/img/meta/apple-touch-startup-image-1668x2224.png">
// <link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"   href="/img/meta/apple-touch-startup-image-1668x2388.png">
// <link rel="apple-touch-startup-image" media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"  href="/img/meta/apple-touch-startup-image-2048x2732.png">
// <link rel="apple-touch-startup-image" media="(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: portrait)"  href="/img/meta/apple-touch-startup-image-1620x2160.png">
// <link rel="apple-touch-startup-image" media="(device-width: 320px) and (device-height: 568px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"   href="/img/meta/apple-touch-startup-image-1136x640.png">
// <link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 667px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"   href="/img/meta/apple-touch-startup-image-1334x750.png">
// <link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"   href="/img/meta/apple-touch-startup-image-1792x828.png">
// <link rel="apple-touch-startup-image" media="(device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"   href="/img/meta/apple-touch-startup-image-2436x1125.png">
// <link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 736px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"   href="/img/meta/apple-touch-startup-image-2208x1242.png">
// <link rel="apple-touch-startup-image" media="(device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape)"   href="/img/meta/apple-touch-startup-image-2688x1242.png">
// <link rel="apple-touch-startup-image" media="(device-width: 768px) and (device-height: 1024px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"  href="/img/meta/apple-touch-startup-image-2048x1536.png">
// <link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1112px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"  href="/img/meta/apple-touch-startup-image-2224x1668.png">
// <link rel="apple-touch-startup-image" media="(device-width: 834px) and (device-height: 1194px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"  href="/img/meta/apple-touch-startup-image-2388x1668.png">
// <link rel="apple-touch-startup-image" media="(device-width: 1024px) and (device-height: 1366px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)" href="/img/meta/apple-touch-startup-image-2732x2048.png">
// <link rel="apple-touch-startup-image" media="(device-width: 810px) and (device-height: 1080px) and (-webkit-device-pixel-ratio: 2) and (orientation: landscape)"  href="/img/meta/apple-touch-startup-image-2160x1620.png">
// <link rel="icon" type="image/png" sizes="228x228" href="/img/meta/coast-228x228.png">
// <meta name="msapplication-TileColor" content="#fff">
// <meta name="msapplication-TileImage" content="/img/meta/mstile-144x144.png">
// <meta name="msapplication-config" content="/img/meta/browserconfig.xml">
// <link rel="yandex-tableau-widget" href="/img/meta/yandex-browser-manifest.json">
